import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language, changeLanguage } = useLanguage();

  // 1. Sync State FROM URL (Priority: URL > State)
  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(part => part !== '');
    const urlLanguagePrefix = pathParts[0];

    if (urlLanguagePrefix === 'en') {
      if (language !== 'en') changeLanguage('en');
    } else if (urlLanguagePrefix !== 'ru') {
      // URL has no prefix (Implies default/Russian)
      // BUT check if we should redirect to EN based on User Preference
      // ONLY if we are at root/landing, or consistent navigation?
      // Actually, if I am at `/some-path`, I am visually on Russian version.
      // So I should set state to 'ru', UNLESS localStorage explicitly wants 'en' AND I am at root?
      // No, if I am at `/`, and localStorage is 'en', I should be redirected.

      const savedLang = localStorage.getItem('language');
      if (savedLang === 'en') {
        // User wants EN, but is on root/unprefixed. Redirect to EN.
        // Avoid infinite loop if we are just transitioning.
        // This logic handles "Auto-redirect to EN for EN users"
        navigate('/en' + (location.pathname === '/' ? '' : location.pathname), { replace: true });
      } else {
        // User implies RU (or has no pref). Set state to RU.
        if (language !== 'ru') changeLanguage('ru');
      }
    }
  }, [location.pathname]); // Only run when URL changes (or on mount)

  // 2. Sync URL FROM State (for programmatic changes, if any)
  // This might conflict if Topbar changes state directly.
  // Best practice: Topbar changes URL. URL changes State (Effect 1).
  // This Effect 2 is mainly for initial load if State was restored differently?
  // Let's keep it minimal or remove if Topbar is pure navigation.

  return null;
};

export default LanguageRedirect;